namespace $.$$ {

	export class $shm_hitalama_map_page_arrow extends $.$shm_hitalama_map_page_arrow {

		dx() {
			return this.to()[0] - this.from()[0]
		}

		dy() {
			return this.to()[1] - this.from()[1]
		}

		left_px() {
			return this.from()[0] + 'px'
		}

		top_px() {
			return this.from()[1] + 'px'
		}

		length_px() {
			return Math.max( 0, Math.hypot( this.dx(), this.dy() ) - 8 ) + 'px'
		}

		transform() {
			return `rotate(${ Math.atan2( this.dy(), this.dx() ) }rad)`
		}

	}

}
